/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a Phred quality score?`)
};

const es_phred_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es una puntuación de calidad Phred?`)
};

const de_phred_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist ein Phred-Qualitätswert?`)
};

const nl_phred_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een Phred-kwaliteitsscore?`)
};

const fr_phred_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'un score de qualité Phred ?`)
};

const it_phred_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è un punteggio di qualità Phred?`)
};

const pt_br2_phred_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é um escore de qualidade Phred?`)
};

const pt_phred_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é uma pontuação de qualidade Phred?`)
};

const ja_phred_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred品質スコアとは何ですか？`)
};

const zh_phred_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 Phred 质量分数？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_faq_q1", locale)
	if (locale === "en") return en_phred_faq_q1(inputs)
	if (locale === "es") return es_phred_faq_q1(inputs)
	if (locale === "de") return de_phred_faq_q1(inputs)
	if (locale === "nl") return nl_phred_faq_q1(inputs)
	if (locale === "fr") return fr_phred_faq_q1(inputs)
	if (locale === "it") return it_phred_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_phred_faq_q1(inputs)
	if (locale === "pt") return pt_phred_faq_q1(inputs)
	if (locale === "ja") return ja_phred_faq_q1(inputs)
	return zh_phred_faq_q1(inputs)
};